export const payslipCompanyOffices = (state) => state.payslipCompanyOffices
export const payslipOfficeEmployees = (state) => state.payslipOfficeEmployees
export const currentEmployeePayslip = (state) => state.currentEmployeePayslip

export const getPayslipStatus = (state) => state.payslipStatus